import cn from 'classnames';
import { Button } from '@fabric-ds/react';

import { NumResults } from '../numResults/NumResults';
import { SaveSearch } from '../saveSearch/SaveSearch';
import { AutocompleteData, Filters, ResultDataStats } from '@/domain';

import styles from './MobileTopBar.module.css';

type MobileTopBarProps = {
    hideFilters: () => void;
    showFilters: () => void;
    showFiltersOverlay: boolean;
    stats: ResultDataStats;
    isLoggedIn: boolean;
    filters: Filters;
    autocompleteData: AutocompleteData;
};

export const MobileTopBar = (props: MobileTopBarProps) => {
    const hideFilters = () => {
        window.removeEventListener('popstate', hideFilters);
        props.hideFilters();
    };

    const showFilters = () => {
        window.addEventListener('popstate', hideFilters);
        props.showFilters();
    };

    return (
        <div className="md:hidden h-64" data-testid="mobileTopBar">
            <div className={cn(styles.container, 'grid grid-cols-3 p-16 items-center border-b fixed left-0 right-0 bg-white md:hidden')}>
                <SaveSearch filters={props.filters} autocompleteData={props.autocompleteData} isLoggedIn={props.isLoggedIn} />
                <NumResults stats={props.stats} className="text-center" hideText />
                <Button
                    small
                    primary={props.showFiltersOverlay}
                    className="ml-auto"
                    data-testid="showOverlay"
                    onClick={props.showFiltersOverlay ? hideFilters : showFilters}>
                    {props.showFiltersOverlay ? 'Vis resultat' : 'Endre søk'}
                </Button>
            </div>
        </div>
    );
};
